// Copyright (c) 2016 Deere & Company

import DealerTransferHistory from '../../../reports/dealer-transfer-history/state-connector';

export default {
    component: DealerTransferHistory,
    name: 'DEALER_TRANSFER_HISTORY',
    path: 'dealer-transfer-history'
};



// WEBPACK FOOTER //
// ./src/routes/products/reports/dealer-transfer-history.js